import ReducerUtils from "../../../utils/ReducerUtils"
import Actions      from "../../../model/constant/actions"


const savingStrategies = ReducerUtils.createReducer(false,{
  [Actions.SAVING_STRATEGIES] : (state,action)=>action.status,
})

export default savingStrategies